/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/prefer-default-export */
import React, { useState, useEffect } from 'react'
import s from './FileInput.module.css'

export function FileInput({
  initialFileUrl,
  onFileChange,
  onRemove,
  isLoading,
  accept = 'image/*',
  label = 'Choose image',
}) {
  const [previewUrl, setPreviewUrl] = useState(initialFileUrl || null)

  useEffect(() => {
    setPreviewUrl(initialFileUrl)
  }, [initialFileUrl])

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0]
    if (selectedFile) {
      const fileReader = new FileReader()

      fileReader.onload = () => {
        const base64Url = fileReader.result
        setPreviewUrl(base64Url)
      }

      fileReader.readAsDataURL(selectedFile)

      if (onFileChange) {
        onFileChange(selectedFile)
      }
    }
  }

  const handleRemove = () => {
    setPreviewUrl(null)
    if (onRemove) {
      onRemove()
    }

    const fileInput = document.getElementById('file-input')
    if (fileInput) {
      fileInput.value = ''
    }
  }

  return (
    <div className={s.root}>
      {previewUrl ? (
        <div className={s.preview}>
          <img src={previewUrl} alt="Preview" className={s.previewImage} />
        </div>
      ) : (
        <div className={s.placeholder}>
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <g clipPath="url(#clip0_64_88)">
              <path d="M5 16H27" stroke="#C4C4C4" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M16 5V27" stroke="#C4C4C4" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
              <clipPath id="clip0_64_88">
                <rect width="32" height="32" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      )}

      <div className={s.controls}>
        <input
          disabled={isLoading}
          type="file"
          accept={accept}
          onChange={handleFileChange}
          style={{ display: 'none' }}
          id="file-input"
        />
        <label htmlFor="file-input" className={s.label}>
          {previewUrl ? 'Replace' : label}
        </label>

        {previewUrl && onRemove && (
          <button disabled={isLoading} type="button" className={s.removeButton} onClick={handleRemove}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <g clipPath="url(#clip0_64_95)">
                <path d="M13.5 3.5H2.5" stroke="#FF8585" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6.5 6.5V10.5" stroke="#FF8585" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9.5 6.5V10.5" stroke="#FF8585" strokeLinecap="round" strokeLinejoin="round" />
                <path
                  d="M12.5 3.5V13C12.5 13.1326 12.4473 13.2598 12.3536 13.3536C12.2598 13.4473 12.1326 13.5 12 13.5H4C3.86739 13.5 3.74021 13.4473 3.64645 13.3536C3.55268 13.2598 3.5 13.1326 3.5 13V3.5"
                  stroke="#FF8585"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10.5 3.5V2.5C10.5 2.23478 10.3946 1.98043 10.2071 1.79289C10.0196 1.60536 9.76522 1.5 9.5 1.5H6.5C6.23478 1.5 5.98043 1.60536 5.79289 1.79289C5.60536 1.98043 5.5 2.23478 5.5 2.5V3.5"
                  stroke="#FF8585"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_64_95">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>{' '}
            Delete
          </button>
        )}
      </div>
    </div>
  )
}
